/**
 * The code-split page components the route table mounts.
 *
 * Apart from the table so each module exports one kind of thing: this one
 * exports components only, leaving `routes/index.tsx` free of component
 * declarations and therefore refreshable.
 */

import { lazy } from 'react'

export const HomePage = lazy(() => import('@/pages/HomePage'))
export const DashboardPage = lazy(() => import('@/pages/DashboardPage'))
export const ProjectDetailPage = lazy(() => import('@/pages/ProjectDetailPage'))
export const ProjectsListPage = lazy(() => import('@/pages/ProjectsListPage'))
export const CreateProjectPage = lazy(() => import('@/pages/CreateProjectPage'))
export const OnboardProjectPage = lazy(() => import('@/pages/OnboardProjectPage'))
export const CollectorsPage = lazy(() => import('@/pages/CollectorsPage'))
export const SearchPage = lazy(() => import('@/pages/SearchPage'))
export const SubjectsPage = lazy(() => import('@/pages/SubjectsPage'))
export const EpisodesPage = lazy(() => import('@/pages/EpisodesPage'))
export const ClaimsReviewPage = lazy(() => import('@/pages/ClaimsReviewPage'))
export const AnalyticsPage = lazy(() => import('@/pages/AnalyticsPage'))
export const ProceduralMemoryPage = lazy(() => import('@/pages/ProceduralMemoryPage'))
export const KnowledgeBasePage = lazy(() => import('@/pages/KnowledgeBasePage'))
export const MemoryModelPage = lazy(() => import('@/pages/MemoryModel'))
export const TokenAnalyticsPage = lazy(() => import('@/pages/TokenAnalyticsPage'))
export const CodeHealthPage = lazy(() => import('@/pages/CodeHealthPage'))
export const TodoListPage = lazy(() => import('@/pages/TodoListPage'))
export const IdeasPage = lazy(() => import('@/pages/IdeasPage'))
export const IdeaDetailPage = lazy(() => import('@/pages/IdeaDetailPage'))
export const RemindersPage = lazy(() => import('@/pages/RemindersPage'))
export const PRDsPage = lazy(() => import('@/pages/PRDsPage'))
export const PromptLibraryPage = lazy(() => import('@/pages/PromptLibraryPage'))
export const DispatchPage = lazy(() => import('@/pages/DispatchPage'))
export const AccessControlPage = lazy(() => import('@/pages/AccessControlPage'))
export const TelemetryPoliciesPage = lazy(() => import('@/pages/TelemetryPoliciesPage'))
export const SessionSummariesPage = lazy(() => import('@/pages/SessionSummariesPage'))
export const ModelCapabilitiesPage = lazy(() => import('@/pages/ModelCapabilitiesPage'))
export const IntegrationsPage = lazy(() => import('@/pages/IntegrationsPage'))
export const NotFoundPage = lazy(() => import('@/pages/NotFoundPage'))
export const CCSupport = lazy(() => import('@/pages/CCSupport').then(module => ({ default: module.CCSupport })))
export const SessionDetailPage = lazy(() => import('@/pages/SessionDetailPage'))
export const IntakePage = lazy(() => import('@/pages/IntakePage'))
export const UsagePage = lazy(() => import('@/pages/UsagePage'))
